<template>

    <div class="input-group | vn-input-radio" :class="cssInputClass">

        <label :for="instanceId" v-html="field.title"></label>

        <div :class="'radio-groups num-groups_' + field.value_list.length ">
            <div class="radio-group" v-for="prop in field.value_list">
                <input
                    :name="key"
                    :id="instanceId + '_' + prop.key"
                    type="radio"
                    :value="prop.label"
                    v-model="value"
                    @blur="clearError"
                />
                <label class="radio-label" :for="instanceId + '_' + prop.key"><span v-html="prop.label"></span></label>
            </div>
        </div>

        <span class="error-message" v-if="gotError"> {{ errorMessage }} </span>
    </div>

</template>

<script>

export default {
    name : "InputCheckbox",
}

</script>

<script setup>

import useFormInput       from "../../composables/useFormInput";
import { onMounted, ref } from 'vue';
import { uniqueId }       from 'lodash-es';

let props = defineProps( [ "field" ] );

let { gotError, clearError, cssInputClass, errorMessage, value, key, exposed } = useFormInput( props );

defineExpose( exposed );

let instanceId = ref( null );


onMounted( () =>
{
    if ( instanceId.value === null )
    {
        instanceId.value = uniqueId( props.field.key + '_' );
    }
} )

</script>
